<template>
  <RevCheckbox
    id="next-task-checkbox"
    data-qa="next-task-checkbox"
    :model-value="isChecked"
    @update:model-value="handleCheck"
  >
    <template #label>{{ i18n(translations.checkboxLabel) }}</template>
  </RevCheckbox>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCheckbox } from '@ds/components/Checkbox'

import translations from './NextTaskCheckbox.translations'

const emit = defineEmits<{
  'update:modelValue': [isChecked: boolean]
}>()

const props = defineProps<{ modelValue: boolean }>()

const isChecked = ref(props.modelValue)

const i18n = useI18n()

function handleCheck(value: boolean | string[]) {
  if (typeof value === 'string') return

  if (typeof value === 'boolean') {
    isChecked.value = value

    emit('update:modelValue', isChecked.value)
  }
}
</script>
